import { getStoredLoginIdentifier } from '../auth/sessionToken';

const STORAGE_KEY_PREFIX = 'ofrontend.businessClientWorkerAvatars';

function storageKey(): string {
  const loginId = getStoredLoginIdentifier()?.trim().toLowerCase();
  return loginId ? `${STORAGE_KEY_PREFIX}:${loginId}` : `${STORAGE_KEY_PREFIX}:anonymous`;
}

function readAvatarMap(): Record<string, string> {
  try {
    const raw = localStorage.getItem(storageKey());
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    const map: Record<string, string> = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (typeof key === 'string' && typeof value === 'string' && value.trim()) {
        map[key.trim()] = value.trim();
      }
    }
    return map;
  } catch {
    return {};
  }
}

function writeAvatarMap(map: Record<string, string>): void {
  try {
    localStorage.setItem(storageKey(), JSON.stringify(map));
  } catch {
    /* ignore quota */
  }
}

/** Employer-side cache when GET /profile/workers omits worker photos after upload. */
export function loadWorkerListAvatarSrc(workerId: string): string | null {
  const id = workerId.trim();
  if (!id) {
    return null;
  }
  return readAvatarMap()[id] ?? null;
}

export function persistWorkerListAvatarSrc(workerId: string, avatarSrc: string): void {
  const id = workerId.trim();
  const src = avatarSrc.trim();
  if (!id || !src) {
    return;
  }
  const map = readAvatarMap();
  map[id] = src;
  writeAvatarMap(map);
}
